import { createMongoAbility } from '@casl/ability'
import { abilitiesPlugin } from '@casl/vue'

export default function (app) {
  // Читаем ability rules из localStorage
  const userAbilityRules = localStorage.getItem('userAbilityRules')
  const parsedRules = userAbilityRules ? JSON.parse(userAbilityRules) : []
  const initialAbility = createMongoAbility(parsedRules)

  app.use(abilitiesPlugin, initialAbility, {
    useGlobalProperties: true,
  })
}
